import {createListViewColumns, initKendoGrid} from "./ListViewColumns";
import {
    ajaxJSONWithoutWait,
    areEqual,
    getFirstNotEmptyObj,
    isAnyEqualToFirst,
    isNotEmptyOrNull,
    registerOnWindowResize
} from "../../common/NamaCommon";
import * as ts from "../../common/Translator";
import {getListViewTitle, isArabic, translateTitledId} from "../../common/Translator";
import * as bf from "../../constants/BusinessFunction";
import {userCan, userCanCreate} from "../../login/Security";
import * as CapabilityType from '../../constants/CapabilityType'
import ListScreenTemplate from "../../compiled-templates/ListScreenTemplate";
import {constructMoreActionsMenu} from "../edit/MoreActionsMenu";
import {of} from "../../widgets/ActionPlaceholder";
import * as GenericActions from "../../constants/GenericActions";
import {isReplicateOptions} from "../../routing/NestMode";
import * as BSEntities from "../../constants/BSEntities";
import {MoreMenuItem} from "../../views/edit/MoreMenuItem";
import * as ConstantViewNames from "../../constants/ConstantViewNames";
import {separator} from "../edit/MoreMenuItem";
import * as CommonConstants from "../../constants/CommonConstants";
import {CriteriaEditorWidget} from "./CriteriaEditorWidget";
import {CriteriaExpressionSerializer} from "../../common/CriteriaAndQuestionsURLParser";
import {exportButton} from "../ReportViewer";
import * as OutputFormat from "../../constants/OutputFormat";
import {JSCriteriaBuilder} from "../../common/JSCriteriaBuilder";
import * as metadata from "../../common/Metadata";
import {TreeViewImpl} from "../treeView/TreeViewImpl";
import {TreeViewForListView} from "../treeView/TreeViewForListView";
import {ListViewSortByBar} from "./ListViewSortByBar";
import * as places from "../../routing/places";
import {NamaRouterInstance} from "../../routing/NamaRouter";
import {NamaKendoWindow} from "../NamaKendoWindow";
import ResultSettingsTemplate from "../../compiled-templates/ResultSettingsTemplate";
import {calcBtnTitle} from "../edit/EditScreenToolbar";
import {getEntityCustomReports, getMenuLineBySrc, isDocument} from "../../login/ClientCache";
import {CustomReportLauncherMenuItem} from "../edit/CustomReportLauncherMenuItem";
import * as ShowCustomRepIn from "../../constants/ShowCustomRepIn";
import {printForm} from "../../common/NaMaPrinting";
import {CriteriaAndQuestionsOverrider} from "./CriteriaAndQuestionsOverrider";
import {ApprovalAndNotificationOverrider} from "./ApprovalAndNotificationOverrider";
import {currentFontType} from "../KednoThemeChooser";
import {MultiApproveDialog} from "./MultiApproveDialog";
import {approveCase} from "../../widgets/ApprovalsAndNotifications";
import * as urls from "../../constants/NamaURLS";
import {isMobileDevice} from "../../common/GUIUtilities";
import {entitiesWithLedgerEffects, scCostDocs, scLedgerDocs} from "../../constants/EntitiesWithLedgerEffectsOrWithParents";
import {getColWidth, setColWidth} from "../StorageUtil";
import * as DomainBaseEntities from "../../constants/DomainBaseEntities";
import * as notifier from "../../common/ErrorsNotification";
/**
 * @extends NamaGridOwner
 */
export class ListScreenView {
    /**
     *
     * @param {ListPresenter} presenter
     */
    constructor(presenter) {
        let that = this;
        that.presenter = presenter;
        that.metaData = presenter.metaData;
        that.overrider = that.getListViewOverrider(presenter.entityType, presenter.place.listViewName);
    }

    render() {
        let that = this;
        let presenter = that.presenter;
        let place = presenter.place;
        let title = getListViewTitle(presenter.entityType, place.listViewName, presenter.preferences.listLayout, getMenuLineBySrc(place.src));
        that.title = title;
        let containerDiv = $(ListScreenTemplate({
            entityType: title,
            translateId: ts.translateId,
        }));
        containerDiv.find(".page-top-header-name").css("font-family", currentFontType());
        if (presenter.block)
            containerDiv.find(".page-top-header-name").remove();
        that._createDisplayColumns();
        that.rootElement = containerDiv;
        that.rootElement.find("#grid").data("namaGrid", that);
        that._initKendoToolbar();
        that.initCriteriaWidget();
        new ListViewSortByBar(presenter, that.rootElement.find("#sortByFields")).render();
        if (isArabic()) {
            that.rootElement.find("#splitter").addClass("k-rtl");
            that.rootElement.find("#grid").addClass("k-rtl");
        } else {
            that.rootElement.find("#splitter").removeClass("k-rtl");
            that.rootElement.find("#grid").removeClass("k-rtl");
        }
        initKendoGrid(this);
        // if (isArabic())
        //     that.rootElement.find("#grid .k-grid-header").css("padding-right", "0px");
        that.rootElement.on("click", "#approveCurrent", (e) => {
            let grid = that.rootElement.find("#grid").data("kendoGrid");
            let row = $(e.target).closest("tr");
            let dataItem = grid.dataItem(row);
            let apCaseId = dataItem.values["apcase.id"];
            approveCase(apCaseId);
        });
        return containerDiv;
    }

    autoFitLocalStorageKey() {
        let that = this;
        let presenter = that.presenter;
        let place = presenter.place;
        return presenter.entityType + place.listViewName + "autoFitColsApplied";
    }

    layoutPrefix() {
        return "list";
    }

    place_(){
        return this.presenter.place;
    }

    toolBar_() {
        return this.rootElement.find("#listScreenToolbar");
    }

    getListViewOverrider(entityType, listViewName) {
        let that = this;
        if (areEqual(entityType, BSEntities.ApprovalDefinition)
            && isAnyEqualToFirst(listViewName, ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME,
                ConstantViewNames.EMPLOYEE_READ_NOTIFICATIONS_SCREEN_NAME))
            return new ApprovalAndNotificationOverrider(that.presenter);
        return new CriteriaAndQuestionsOverrider(that.presenter);
    }

    overrideCriteria(criteria) {
        return this.overrider.overrideCriteria(criteria);
    }

    overrideQuestionFields(questionFields, source) {
        return this.overrider.overrideQuestionFields(questionFields, source);
    }
    initCriteriaWidget() {
        let that = this;
        let oldCriteria = null;
        let layoutId = that.presenter.preferences.listLayout.id;
        let cachedCriteria = metadata.getCachedCriteria(that.presenter.entityType, layoutId);
        if (cachedCriteria && cachedCriteria.expressions && cachedCriteria.expressions.length) {
            if (that.presenter.preferences.listLayout.defaultCriteria) {
                let criteriaFromStr = JSCriteriaBuilder.criteriaFromStr(cachedCriteria);
                cachedCriteria = criteriaFromStr.addDefaultCriteria(that.presenter.preferences.listLayout.defaultCriteria);
            }
            cachedCriteria = that.overrideCriteria(cachedCriteria);
            oldCriteria = cachedCriteria;
            let cachedQuestionFields = metadata.getCachedQuestionFields(that.presenter.entityType, layoutId);
            cachedQuestionFields = that.overrideQuestionFields(cachedQuestionFields, []);
            that.filledQuestionFields = cachedQuestionFields;
        }
        else {
            oldCriteria = new CriteriaExpressionSerializer().criteriaFromURL(this.presenter.place.criteria);
        }
        let criteriaFields = that.presenter.preferences.listLayout.criteriaFields;
        if (criteriaFields && criteriaFields.length) {
            that.criteriaWidget = new CriteriaEditorWidget({
                rootElement: that.rootElement,
                presenter: that.presenter,
                oldCriteria,
                metadata: that.presenter.metaData,
                entityType: that.presenter.entityType,
                criteriaFields: criteriaFields,
                owner:that
            });
            that.criteriaWidget.render();
        }
    }

    initSplitter(forceDrawTree, callBack) {
        let that = this;
        let splitterDiv = that.rootElement.find("#splitter");
        if (forceDrawTree || (that.presenter.hasTree() && !splitterDiv.data("kendoSplitter"))) {
            let treeViewForListView = new TreeViewForListView(that.presenter.entityType);
            let treeViewImpl = new TreeViewImpl(treeViewForListView.getTreeModelProviderForListView(),
                treeViewForListView.getHelperForListView(), that.presenter, () => that.presenter.onListView());
            that.presenter.treeView = treeViewImpl;
            treeViewImpl.drawTreeView(that, callBack);
            splitterDiv.kendoSplitter({
                orientation: "horizontal",
                panes: [{}, {size: '15%', collapsible: true}]
            });
        }
        else if(splitterDiv.data("kendoSplitter")){
            splitterDiv.data("kendoSplitter").toggle(".k-pane:last");
        }
    }

    calcPageSize() {
        let psize = this.presenter.place.pageSize;
        if ("all".toLocaleLowerCase() === psize)
            psize = 0;
        if (psize < 0)
            psize = 0;
        return psize;
    }

    calcCurrentPage() {
        let page = parseInt(this.presenter.place.currentPage) || 0;
        return page + 1;
    }

    /**
     *
     * @returns {kendo.ui.Grid}
     */
    kendoGrid() {
        return this.rootElement.find("#grid").data("kendoGrid");
    }

    refresh() {
        this.kendoGrid().dataSource.read();
    }

    listToolBarItems() {
        let that = this;
        let presenter = that.presenter;
        let printBtn = {
            type: "splitButton",
            id: 'printBtn',
            icon: 'print',
            attributes: {title: calcBtnTitle(bf.print), class: "k-primary"},
            menuButtons: [
                exportButton("exportAsPDF", "assets/namasoft/img/pdf.png", () => {
                    presenter.onPrint(OutputFormat.PDF);
                }),
                exportButton("exportAsDOCX", "assets/namasoft/img/docx.png", () => {
                    presenter.onPrint(OutputFormat.DOCX);
                }),
                exportButton("exportAsRTF", "assets/namasoft/img/rtf.png", () => {
                    presenter.onPrint(OutputFormat.RTF);
                }),
                exportButton("exportAsXLSX", "assets/namasoft/img/xlsx.png", () => {
                    presenter.onPrint(OutputFormat.XLSX);
                }),
                exportButton("exportAsXLS", "assets/namasoft/img/xls.png", () => {
                    presenter.onPrint(OutputFormat.XLS);
                }),
                exportButton("exportAsODT", "assets/namasoft/img/odt.png", () => {
                    presenter.onPrint(OutputFormat.ODT);
                }),
                exportButton("exportAsODS", "assets/namasoft/img/ods.png", () => {
                    presenter.onPrint(OutputFormat.ODS);
                }),
                exportButton("exportAsPPTX", "assets/namasoft/img/pptx.png", () => {
                    presenter.onPrint(OutputFormat.PPTX);
                }),
                exportButton("sendEmailWithResult", "assets/namasoft/img/mailReport.png", () => {
                    presenter.sendEmail();
                }),
            ],
            click: (e) => presenter.onPrint(OutputFormat.PDF)
        };
        let listViewBtn = {
            type: "button",
            id: bf.listView,
            icon: 'align-justify',
            attributes: {title: calcBtnTitle(bf.listView), class: "k-primary"},
            click: function (e) {
                presenter.onListView();
                //e.preventDefault();
            },
        };
        let treeBtn = {
            type: "button",
            id: 'treeViewBtn',
            spriteCssClass: "fa fa-tree",
            attributes: {title: calcBtnTitle(bf.treeView), class: "k-primary"},
            click: (e) => {
                that.showTreeView();
            }
        };
        let resultSettings = {
            type: "button",
            id: 'resultSettingsBtn',
            icon: 'table-column-delete',
            attributes: {title: calcBtnTitle(bf.resultSettings), class: "k-primary"},
            click: (e) => {
                that.showResultSettingsWindow();
            }
        };
        let homePageBtn = {
            type: "button",
            id: 'homePageBtn',
            spriteCssClass: "fa fa-home",
            attributes: {title: calcBtnTitle('homePage'), class: "k-primary"},
            click: (e) => {
                NamaRouterInstance.goTo(new places.WelcomePlace());
            },
        };
        let moreMenuBtn = {
            type: "button",
            id: 'moreMenu',
            icon: 'more-horizontal',
            text: ts.translateId('more'),
            attributes: {title: calcBtnTitle('more'), class: "k-primary"},
            click: (e) => {
                that.showMoreMenu();
            }
        };
        let toggleFilterAndSort = {
            type: "button",
            id: 'toggleFilterAndSort',
            spriteCssClass: "k-icon k-i-filter-clear",
            attributes: {title: calcBtnTitle('filter'), class: "k-primary"},
            click: (e) => {
                let toggleFiltering = $(e.target);
                let toggleBtnIcon = toggleFiltering.children(".k-icon");
                let hasFilter = toggleBtnIcon.hasClass("k-i-filter");
                that.toggleFilterAndSortAction();
                if (hasFilter)
                    toggleFiltering.addClass("k-state-active");
            },
        };
        let autoFitBtn = {
            type: "button",
            id: 'autoFitCols',
            spriteCssClass: "fa fa-sliders",
            attributes: {title: calcBtnTitle("autoFitColumns"), class: "k-primary"},
            click: (e) => that.autoFitGridColumns()
        };
        let exportCSVBtn = {
            type: "button", id: 'exportcsv',
            icon: 'excel',
            attributes: {title: calcBtnTitle("exportcsv"), class: "k-primary"},
            click: function (e) {
                that.exportToExcel()
            }
        };
        let toolBarItems = [
            {
                type: "button", id: 'newRecord',
                icon: 'plus',
                attributes: {title: calcBtnTitle(bf.newRecord), class: "k-primary"},
                click: function (e) {
                    presenter.onNewRecord()
                }
            }, listViewBtn, printBtn, {
                type: "button",
                id: 'reviseBtn',
                icon: 'track-changes-accept',
                attributes: {title: calcBtnTitle(bf.revise), class: "k-primary"},
                click: (e) => {
                    presenter.revise(this.getSelectedRowsId());
                }
            }, {
                type: "button",
                id: 'unReviseBtn',
                icon: 'track-changes-reject',
                attributes: {title: calcBtnTitle(bf.unrevise), class: "k-primary"},
                click: (e) => {
                    presenter.unRevise(this.getSelectedRowsId());
                }
            }, toggleFilterAndSort, treeBtn, exportCSVBtn, resultSettings, {
                type: "button",
                id: 'deleteBtn',
                icon: 'delete',
                attributes: {title: calcBtnTitle(bf.$delete), class: "k-primary"},
                click: (e) => {
                    that.deleteAction();
                }
            }, autoFitBtn, homePageBtn, moreMenuBtn
        ];
        if (this.presenter.embeddedListView)
            toolBarItems = [listViewBtn, toggleFilterAndSort, treeBtn, exportCSVBtn, resultSettings, autoFitBtn, homePageBtn, moreMenuBtn];
        return toolBarItems;
    }

    deleteAction() {
        let that = this;
        that.presenter.bulkDeleteEntities(that.getSelectedRowsId());
        that.dataSource.read();
    }

    showMoreMenu() {
        let that = this;
        let moreMenuButtons = this.getListViewMoreMenuItems();
        constructMoreActionsMenu(moreMenuButtons, that.rootElement.find("#listScreenToolbar"), that.presenter)
    }

    changeFilteringIcon(hasExpressions) {
        let that = this;
        let filteringBtn = that.rootElement.find("#listScreenToolbar").find("#toggleFilterAndSort");
        let filterIcon = filteringBtn.children(".k-icon");
        if (hasExpressions) {
            filterIcon.removeClass("k-i-filter-clear");
            filterIcon.addClass("k-i-filter");
            filteringBtn.addClass("k-state-active");
        } else {
            filterIcon.removeClass("k-i-filter");
            filterIcon.addClass("k-i-filter-clear");
            filteringBtn.removeClass("k-state-active");
        }
    }

    toggleFilterAndSortAction() {
        let that = this;
        that.rootElement.find("#sortByFields").slideToggle("slow");
        that.rootElement.find("#listScreenFiltering").slideToggle("slow", () => that.setHeightOfListViewGrid());
    }

    _initKendoToolbar() {
        let that = this;
        let rootElement = that.rootElement;
        let presenter = that.presenter;
        let toolbar = rootElement.find("#listScreenToolbar");

        let toolBarItems = that.listToolBarItems();
        toolbar.kendoToolBar({
            items: toolBarItems,
        });
        for (let item of toolBarItems) {
            let span = toolbar.find("#" + item.id).find("span");
            if (span && span.hasClass("fa")) {
                span.removeClass("k-icon");
                span.removeClass("k-sprite");
            }
        }
        toolbar.data("kendoToolBar").resize();
        toolbar.find("#moreMenu").on('mouseover', function (e) {
            e.preventDefault();
            that.showMoreMenu();
        });
        preValidateListScreenToolbarButtons(this, toolbar, presenter);
        toolbar.find("span").css("font-size", "20px");
        let alwaysShowFilterPart = localStorage.getItem("alwaysShowFilterPart");
        if (alwaysShowFilterPart === "true")
            return;
        that.rootElement.find("#sortByFields").hide();
        that.rootElement.find("#listScreenFiltering").hide();
    }

    autoFitGridColumns() {
        let that = this;
        let grid = that.kendoGrid();
        let options = $.extend({}, grid.getOptions());
        for (let i = 0; i < grid.columns.length; i++) {
            let gridColumn = grid.columns[i];
            if (gridColumn.selectable && gridColumn.locked)
                continue;
            grid.autoFitColumn(i);
            setColWidth(that, {column: {id: gridColumn.id}});
            if (gridColumn.width > 400)
                options.columns[i].width = 400;
        }
        localStorage.setItem(that.autoFitLocalStorageKey(), "true");
        localStorage.setItem((that.autoFitLocalStorageKey() + "AutoFitApplied"), "true");
        grid.setOptions(options);
    }

    showTreeView() {
        let that = this;
        that.presenter.place.showTree = !that.presenter.isShowingTree();
        NamaRouterInstance.updateHistoryURLSilently(that.presenter.place);
        that.initSplitter();
    }

    /**
     *
     * @param {Array} moreMenuButtons
     */
    getListLayoutExtraMoreMenuItems(moreMenuButtons) {
        let presenter = this.presenter;
        let ownerId = presenter.preferences.metaData.owner.ownerId;
        if (ownerId === BSEntities.ApprovalDefinition && presenter.preferences.listLayout.id === ConstantViewNames.EMPLOYEE_APPROVALS_SCREEN_NAME) {
            moreMenuButtons.push(new MoreMenuItem("approveSelectedLines", presenter, () => {
                let flatObjects = presenter.view.getSelectedRows();
                let entityTypes = [];
                let entityIds = [];
                let nextStepSequences = [];
                for (let fieldValue of flatObjects) {
                    let id = fieldValue.values["approvedElement"].id;
                    if (entityIds.contains(id))
                        continue;
                    entityTypes.push(fieldValue.values["approvedElement"].entityType);
                    entityIds.push(id);
                    nextStepSequences.push(fieldValue.values["nextStepSequence"]);
                }
                new MultiApproveDialog(presenter, entityTypes, entityIds, nextStepSequences).showPopup();
            }));
        }
        moreMenuButtons.push(separator(presenter));
        let entityCustomReports = getEntityCustomReports(presenter.metaData.owner.ownerId);
        if (entityCustomReports) {
            for (let customRepInfo of entityCustomReports) {
                if (customRepInfo.showIn === ShowCustomRepIn.ListViewMore)
                    moreMenuButtons.push(new CustomReportLauncherMenuItem(presenter, customRepInfo));
            }
        }
        return moreMenuButtons;
    }

    /**
     *
     * @param {Array} moreMenuButtons
     */
    getListLayoutStandardMoreMenuItems(moreActions) {
        let presenter = this.presenter;
        moreActions.push(of(GenericActions.DELETE_SELECTED));
        moreActions.push(of(GenericActions.CREATE_LIST_VIEW_CRITERIA));
        moreActions.push(of(CommonConstants.MORE_MENU_SEPERATOR));
        if (userCan(presenter.entityType, CapabilityType.Import))
            moreActions.push(of(GenericActions.IMPORT_RECORDS));
        if (userCan(presenter.entityType, CapabilityType.Export)) {
            moreActions.push(of(GenericActions.EXPORT_SELECTED));
            moreActions.push(of(GenericActions.EXPORT_PAGE));
            moreActions.push(of(GenericActions.EXPORT_ALL));
        }
        moreActions.push(of(GenericActions.SAVE_DRAFT_RECORDS));
        moreActions.push(of(GenericActions.PREVENT_USAGE));
        moreActions.push(of(GenericActions.ALLOW_USAGE));
    }

    /**
     *
     * @returns {Array}
     */
    getListViewMoreMenuItems() {
        let that = this;
        let presenter = that.presenter;
        if (!userCan(presenter.entityType, CapabilityType.CanViewMoreMenu))
            return [];
        let moreActions = [];
        let moreMenuButtons = [];
        let listLayout = presenter.preferences.listLayout;
        if (listLayout) {
            if (listLayout.moreActions) {
                for (let moreAction of listLayout.moreActions) {
                    let item = of(moreAction.id);
                    item.setTitle(moreAction.title);
                    item.setCustomization(moreAction.customization);
                    moreActions.push(item);
                }
            }
            moreMenuButtons.push(new MoreMenuItem("cancelColumnsAutoFit", presenter, () => {
                localStorage.setItem(that.autoFitLocalStorageKey(), "false");
                let options = $.extend({}, that.kendoGrid().getOptions());
                for (let c of options.columns) {
                    let displayColumn = listLayout.displayColumns.filter(col => col.id === c.id)[0];
                    if (displayColumn)
                        c.width = getFirstNotEmptyObj(getColWidth(presenter, displayColumn.id), displayColumn.width, '10em');
                }
                that.kendoGrid().setOptions(options);
            }));
            moreActions.push(of(CommonConstants.MORE_MENU_SEPERATOR));
            if (!listLayout.hideEntitySpecificFeatures) {
                this.getListLayoutStandardMoreMenuItems(moreActions);
                if (isReplicateOptions()) {
                    moreActions.push(of(GenericActions.RECOMMIT));
                    if (entitiesWithLedgerEffects.contains(presenter.entityType) || scCostDocs.contains(presenter.entityType) || scLedgerDocs.contains(presenter.entityType))
                        moreActions.push(of(GenericActions.REGEN_ACCOUNTING_EFFECTS));
                    if (isDocument(presenter.entityType))
                        moreActions.push(of(GenericActions.REGEN_INVENTORY_EFFECTS));
                    moreActions.push(of(GenericActions.REREPLICATE));
                    moreActions.push(of(GenericActions.REVERT_TO_PREVIOUS_VERSION));
                    if (presenter.entityType === BSEntities.ReportDefinition)
                        moreActions.push(of("updateSystemReports"));
                    if (isAnyEqualToFirst(presenter.entityType, DomainBaseEntities.User, DomainBaseEntities.MasterGroup, DomainBaseEntities.Sector,
                        DomainBaseEntities.Branch, DomainBaseEntities.Department, DomainBaseEntities.LegalEntity, DomainBaseEntities.AnalysisSet,
                        DomainBaseEntities.DocumentBook, DomainBaseEntities.DocumentTerm, BSEntities.DocCategory, BSEntities.FiscalPeriod,
                        BSEntities.FiscalYear, BSEntities.SecurityCapability))
                        moreActions.push(of("cancelActivated"));
                }
                moreActions.push(of(GenericActions.LIST_VIEW_ADD_TO_CURRENT_USER_FAVOURITES));
                moreActions.push(of(GenericActions.ADD_SELECTED_DOCS_TO_LINES_OF_CURRENT_USER_FAVOURITE));
            }
            moreMenuButtons.push(separator(presenter));
            if (moreActions.length > 0) {
                for (let moreAction of moreActions) {
                    if (moreAction.shouldBeAdded()) {
                        let actionId = moreAction.id;
                        if (actionId === CommonConstants.MORE_MENU_SEPERATOR) {
                            moreMenuButtons.push(separator(presenter));
                        } else {
                            let moreMenuItem = new MoreMenuItem(actionId, presenter, null, null, moreAction.subItems, moreAction.customization);
                            if (isNotEmptyOrNull(moreAction.title))
                                moreMenuItem.title = translateTitledId(null, moreAction);
                            moreMenuButtons.push(moreMenuItem);
                        }
                    }
                }
            }
            if (isReplicateOptions() && presenter.entityType === BSEntities.ReportDefinition) {
                //TODO:
                //moreMenuButtons.push(RemoteObjectImporter.openImplRepo());
            }
            if (!listLayout.hideEntitySpecificFeatures) {
                moreMenuButtons.push(new MoreMenuItem("printSelectedRows", presenter, () => {
                    presenter.onPrint(OutputFormat.PDF);
                }));
                moreMenuButtons.push(new MoreMenuItem("printSelectedRowsUsingEditForm", presenter, () => {
                    let listIds = presenter.view.getSelectedRowsId();
                    for (let id of listIds) {
                        printForm(presenter.entityType, id, {resourceId: "main"}, OutputFormat.PDF, presenter.viewName_(), 0, presenter.place.src);
                    }
                }));
            }
            return this.getListLayoutExtraMoreMenuItems(moreMenuButtons);
        }
    }

    getViewRowsId() {
        let grid = this.kendoGrid();
        let viewRows = grid.dataSource.view();
        let ids = [];
        if (!viewRows)
            return ids;
        for (let row of viewRows.items) {
            if (ids.indexOf(row.id) === -1)
                ids.push(row.id);
        }
        return ids;
    }

    getSelectedRowsId() {
        let grid = this.kendoGrid();
        let id = [];
        grid.select().each(function () {
            let rowData = grid.dataItem(this);
            if (id.indexOf(rowData.values.id) === -1)
                id.push(rowData.values.id);
        });
        return id;
    }

    getSelectedRowsEntityTypes() {
        let grid = this.kendoGrid();
        let entityTypes = [];
        grid.select().each(function () {
            let rowData = grid.dataItem(this);
            entityTypes.push(rowData.values.entityType);
        });
        return entityTypes;
    }

    getSelectedRows() {
        let grid = this.kendoGrid();
        let rows = [];
        grid.select().each(function () {
            let rowData = grid.dataItem(this);
            if (rows.filter(r => r.uid === rowData.uid).length == 0)
                rows.push(rowData);
        });
        return rows;
    }

    enableToolbarBtn(btnId) {
        this.rootElement.find("#" + btnId).prop('disabled', false);
    }

    disableToolbarBtn(btnId) {
        this.rootElement.find("#" + btnId).prop('disabled', true);
    }

    get pageSize() {
        return this.kendoGrid().dataSource.pageSize() || 25;
    }

    get currentPage() {
        return this.kendoGrid().dataSource.page() || 1;
    }

    onDataFetched(data) {

    }

    readFromServer(options) {
        this.presenter.fetchFromServer(options);
    }

    _createDisplayColumns() {
        let that = this;
        that.model = {};
        let layoutDisplayColumns = that.presenter.preferences.listLayout.displayColumns;
        let cachedDisplayColumns = that.presenter.getDisplayColumns();
        if (cachedDisplayColumns) {
            for (let i = layoutDisplayColumns.length - 1; i >= 0; i--) {
                if (!cachedDisplayColumns.contains(layoutDisplayColumns[i].id))
                    layoutDisplayColumns[i].displayed = false;
                else
                    layoutDisplayColumns[i].displayed = true;
            }
        }
        that.displayColumns = createListViewColumns(that, {displayColumns: layoutDisplayColumns}, that.model);
    }

    afterAttach() {
        let that = this;
        that.setHeightOfListViewGrid();
        registerOnWindowResize(this.rootElement[0], (e) => {
            that.setHeightOfListViewGrid();
        });
        setTimeout(() => this.setHeightOfListViewGrid());
        that.initSplitter();
    }

    setHeightOfListViewGrid() {
        let windowHeight = $(window).height();
        let navBarHeight = $("#nama-erp-header").outerHeight(true);
        if (this.presenter.wrapperHeight)
        {
            windowHeight = this.presenter.wrapperHeight;
            navBarHeight = 0;
        }
        let pageTopHeaderHeight = this.rootElement.find(".page-top-header").outerHeight(true);
        let h = windowHeight - navBarHeight - 15 - pageTopHeaderHeight;
        let splitter = this.rootElement.find("#splitter");
        splitter.css("height", h);
        if (this.kendoGrid())
            this.kendoGrid().resize();
        let toolbar = this.rootElement.find("#listScreenToolbar").data("kendoToolBar");
        if (toolbar)
            toolbar.resize();
    }

    showResultSettingsWindow() {
        let that = this;
        let layoutDisplayColumns = that.presenter.preferences.listLayout.displayColumns;
        let displayedColumns = [];
        let notDisplayedColumns = [];
        for (let col of layoutDisplayColumns) {
            if (col.displayed === true)
                displayedColumns.push(col);
            else
                notDisplayedColumns.push(col);
        }
        /**
         *
         * @type {namaTypes.NamaWindowBtnData}
         */
        let okBtnData = {
            btnTitle: "ok", btnAction: () => {
                let columns = [...listBox.find("#displayedColumns").data("kendoListBox").dataSource.data()];
                window.closeWindow();
                let layoutDisplayColumns = that.presenter.preferences.listLayout.displayColumns;
                let columnsIDs = columns.map((l) => l.id);
                for (let col of layoutDisplayColumns) {
                    if (columnsIDs.contains(col.id))
                        col.displayed = true;
                    else
                        col.displayed = false;
                }
                that.displayColumns = createListViewColumns(that, {displayColumns: layoutDisplayColumns}, that.model);
                initKendoGrid(that);
                that.presenter.onRefresh();
            }
        };
        /**
         *
         * @type {namaTypes.NamaWindowBtnData}
         */
        let cancelBtnData = {
            btnTitle: "cancel"
        };
        let window = new NamaKendoWindow(bf.resultSettings, okBtnData, cancelBtnData);
        window.width = "60%";
        window.height = "35%";
        if (isMobileDevice()) {
            window.width = "90%";
            window.height = "90%";
        }
        let listBox = $(ResultSettingsTemplate({
            translateId: ts.translateId
        }));
        window.content.append(listBox);
        window.showWindow();
        that.model_ = kendo.data.Model.define({});
        Object.defineProperty(that.model_.prototype, "$translatedFieldId", {
            enumerable: false, configurable: true, get: function () {
                return ts.translate(this.id, that.presenter.entityType)
            }, set: function (value) {
            }
        });
        listBox.find("#displayedColumns").kendoListBox({
            dataSource: new kendo.data.DataSource({
                data: displayedColumns,
                schema: {
                    model: that.model_
                }
            }),
            draggable: true,
            connectWith: "notDisplayedColumns",
            dropSources: ["notDisplayedColumns"],
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
            toolbar: {
                tools: ["transferTo", "transferFrom", "transferAllTo", "transferAllFrom"]
            }
        });

        listBox.find("#notDisplayedColumns").kendoListBox({
            dataSource: new kendo.data.DataSource({
                data: notDisplayedColumns,
                schema: {
                    model: that.model_
                }
            }),
            draggable: true,
            connectWith: "displayedColumns",
            dropSources: ["displayedColumns"],
            dataTextField: "$translatedFieldId",
            dataValueField: "id",
        });
    }

    exportToExcel() {
        if (!userCan(this.presenter.entityType, CapabilityType.Export)) {
            notifier.showError(translateId("noAuthorityOnOperation"));
            return;
        }
        let that = this;
        let grid = that.kendoGrid();
        let selectColumn = null;
        let data = [];
        let header = [];
        data.push(header);
        let listColumns = grid.columns;
        for (let i = 0; i < listColumns.length; i++) {
            let column = listColumns[i];
            if (column.selectable) {
                selectColumn = column;
            } else {
                header.push(column.title.replace("|", " - "));
            }
        }
        let selectedIndices = that.getSelectedRowsIndices();
        if (selectColumn && isNotEmptyOrNull(selectedIndices)) {
            for (let selectedRow of selectedIndices) {
                that.exportRow(data, selectedRow);
            }
        } else {
            for (let i = 0; i < that.getRowCount(); i++) {
                that.exportRow(data, i);
            }
        }
        let req = {
            data: JSON.stringify(data),
            fileName: that.title + ".xlsx"
        };
        ajaxJSONWithoutWait(urls.ExportToExcel, req, (result) => {
                window.open(result.data, "_blank");
            }
        );
    }

    getSelectedRowsIndices() {
        let grid = this.kendoGrid();
        let selectedIndices = [];
        grid.select().each(function () {
            let rowData = grid.dataItem(this);
            let index = grid.dataSource.data().indexOf(rowData);
            if (!selectedIndices.contains(index))
                selectedIndices.push(index);
        });
        return selectedIndices;
    }

    getRowCount() {
        let that = this;
        let grid = that.kendoGrid();
        return grid.dataSource.data().length;
    }

    exportRow(data, rowIndex) {
        let that = this;
        let grid = that.kendoGrid();
        let listColumns = grid.columns;
        if (that.getRowCount() <= rowIndex)
            return;
        let row = [];
        data.push(row);
        let lockedCount = 0;
        let unLockedCount = 0;
        for (let j = 0; j < listColumns.length; j++) {
            let column = listColumns[j];
            if (column.selectable)
                continue;
            let cell;
            if (column.locked) {
                cell = grid.lockedTable.find("tr:eq(" + rowIndex + ")").find("td:eq(" + lockedCount + ")");
                lockedCount++;
            } else {
                cell = grid.tbody.find("tr:eq(" + rowIndex + ")").find("td:eq(" + unLockedCount + ")");
                unLockedCount++;
            }
            if (!cell)
                continue;
            row.push(cell.text());
        }
    }
}

function preValidateListScreenToolbarButtons(that, toolbar, presenter) {
    let toolbarData = toolbar.data("kendoToolBar");
    if (that.presenter.preferences.listLayout.hideEntitySpecificFeatures) {
        toolbarData.hide(toolbar.find("#newRecord"));
        toolbarData.hide(toolbar.find("#reviseBtn"));
        toolbarData.hide(toolbar.find("#unReviseBtn"));
        toolbarData.hide(toolbar.find("#deleteBtn"));
        if (!that.alwaysShowTreeViewButton)
            toolbarData.hide(toolbar.find("#treeViewBtn"));
        else
            toolbarData.show(toolbar.find("#treeViewBtn"));
        return;
    }
    toolbarData.enable(toolbar.find("#newRecord"), userCanCreate(presenter.entityType));
    toolbarData.enable(toolbar.find("#reviseBtn"), userCan(presenter.entityType, CapabilityType.Revise));
    toolbarData.enable(toolbar.find("#unReviseBtn"), userCan(presenter.entityType, CapabilityType.Unrevise));
    toolbarData.enable(toolbar.find("#treeViewBtn"), presenter.supportsTreeInListView());
}

